// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"58059251","225":"990364ee","299":"7664af1c","530":"df499937","725":"c5e8d6ed","801":"e976dc94"}[chunkId] + ".chunk.css";
};